import(/* webpackMode: "eager" */ "/workspace/app/chat/page.tsx");
